export const Theme = {
  RETRO: "R",
  MODERN: "M",
};
